(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8890],{

/***/ 78890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ advertise_GetInTouchForm; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(17599);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(95827);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ./components/advertise/GetInTouchForm/getintouchform.module.scss
var getintouchform_module = __webpack_require__(89429);
var getintouchform_module_default = /*#__PURE__*/__webpack_require__.n(getintouchform_module);
;// CONCATENATED MODULE: ./enums/countries.tsx
var allCountries = [
    {
        name: "Afghanistan",
        code: "AF"
    },
    {
        name: "Albania",
        code: "AL"
    },
    {
        name: "Algeria",
        code: "DZ"
    },
    {
        name: "Andorra",
        code: "AD"
    },
    {
        name: "Angola",
        code: "AO"
    },
    {
        name: "Antigua and Barbuda",
        code: "AG"
    },
    {
        name: "Argentina",
        code: "AR"
    },
    {
        name: "Armenia",
        code: "AM"
    },
    {
        name: "Australia",
        code: "AU"
    },
    {
        name: "Austria",
        code: "AT"
    },
    {
        name: "Azerbaijan",
        code: "AZ"
    },
    {
        name: "Bahamas",
        code: "BS"
    },
    {
        name: "Bahrain",
        code: "BH"
    },
    {
        name: "Bangladesh",
        code: "BD"
    },
    {
        name: "Barbados",
        code: "BB"
    },
    {
        name: "Belarus",
        code: "BY"
    },
    {
        name: "Belgium",
        code: "BE"
    },
    {
        name: "Belize",
        code: "BZ"
    },
    {
        name: "Benin",
        code: "BJ"
    },
    {
        name: "Bhutan",
        code: "BT"
    },
    {
        name: "Bolivia",
        code: "BO"
    },
    {
        name: "Bosnia and Herzegovina",
        code: "BA"
    },
    {
        name: "Botswana",
        code: "BW"
    },
    {
        name: "Brazil",
        code: "BR"
    },
    {
        name: "Brunei",
        code: "BN"
    },
    {
        name: "Bulgaria",
        code: "BG"
    },
    {
        name: "Burkina Faso",
        code: "BF"
    },
    {
        name: "Burundi",
        code: "BI"
    },
    {
        name: "Cabo Verde",
        code: "CV"
    },
    {
        name: "Cambodia",
        code: "KH"
    },
    {
        name: "Cameroon",
        code: "CM"
    },
    {
        name: "Canada",
        code: "CA"
    },
    {
        name: "Central African Republic",
        code: "CF"
    },
    {
        name: "Chad",
        code: "TD"
    },
    {
        name: "Chile",
        code: "CL"
    },
    {
        name: "China",
        code: "CN"
    },
    {
        name: "Colombia",
        code: "CO"
    },
    {
        name: "Comoros",
        code: "KM"
    },
    {
        name: "Congo",
        code: "CG"
    },
    {
        name: "Costa Rica",
        code: "CR"
    },
    {
        name: "C\xf4te d'Ivoire",
        code: "CI"
    },
    {
        name: "Croatia",
        code: "HR"
    },
    {
        name: "Cuba",
        code: "CU"
    },
    {
        name: "Cyprus",
        code: "CY"
    },
    {
        name: "Czech Republic",
        code: "CZ"
    },
    {
        name: "Denmark",
        code: "DK"
    },
    {
        name: "Djibouti",
        code: "DJ"
    },
    {
        name: "Dominica",
        code: "DM"
    },
    {
        name: "Dominican Republic",
        code: "DO"
    },
    {
        name: "East Timor",
        code: "TL"
    },
    {
        name: "Ecuador",
        code: "EC"
    },
    {
        name: "Egypt",
        code: "EG"
    },
    {
        name: "El Salvador",
        code: "SV"
    },
    {
        name: "Equatorial Guinea",
        code: "GQ"
    },
    {
        name: "Eritrea",
        code: "ER"
    },
    {
        name: "Estonia",
        code: "EE"
    },
    {
        name: "Eswatini",
        code: "SZ"
    },
    {
        name: "Ethiopia",
        code: "ET"
    },
    {
        name: "Fiji",
        code: "FJ"
    },
    {
        name: "Finland",
        code: "FI"
    },
    {
        name: "France",
        code: "FR"
    },
    {
        name: "Gabon",
        code: "GA"
    },
    {
        name: "Gambia",
        code: "GM"
    },
    {
        name: "Georgia",
        code: "GE"
    },
    {
        name: "Germany",
        code: "DE"
    },
    {
        name: "Ghana",
        code: "GH"
    },
    {
        name: "Greece",
        code: "GR"
    },
    {
        name: "Grenada",
        code: "GD"
    },
    {
        name: "Guatemala",
        code: "GT"
    },
    {
        name: "Guinea",
        code: "GN"
    },
    {
        name: "Guinea-Bissau",
        code: "GW"
    },
    {
        name: "Guyana",
        code: "GY"
    },
    {
        name: "Haiti",
        code: "HT"
    },
    {
        name: "Honduras",
        code: "HN"
    },
    {
        name: "Hungary",
        code: "HU"
    },
    {
        name: "Iceland",
        code: "IS"
    },
    {
        name: "India",
        code: "IN"
    },
    {
        name: "Indonesia",
        code: "ID"
    },
    {
        name: "Iran",
        code: "IR"
    },
    {
        name: "Iraq",
        code: "IQ"
    },
    {
        name: "Ireland",
        code: "IE"
    },
    {
        name: "Italy",
        code: "IT"
    },
    {
        name: "Jamaica",
        code: "JM"
    },
    {
        name: "Japan",
        code: "JP"
    },
    {
        name: "Jordan",
        code: "JO"
    },
    {
        name: "Kazakhstan",
        code: "KZ"
    },
    {
        name: "Kenya",
        code: "KE"
    },
    {
        name: "Kiribati",
        code: "KI"
    },
    {
        name: "Korea, North",
        code: "KP"
    },
    {
        name: "Korea, South",
        code: "KR"
    },
    {
        name: "Kosovo",
        code: "XK"
    },
    {
        name: "Kuwait",
        code: "KW"
    },
    {
        name: "Kyrgyzstan",
        code: "KG"
    },
    {
        name: "Laos",
        code: "LA"
    },
    {
        name: "Latvia",
        code: "LV"
    },
    {
        name: "Lebanon",
        code: "LB"
    },
    {
        name: "Lesotho",
        code: "LS"
    },
    {
        name: "Liberia",
        code: "LR"
    },
    {
        name: "Libya",
        code: "LY"
    },
    {
        name: "Liechtenstein",
        code: "LI"
    },
    {
        name: "Lithuania",
        code: "LT"
    },
    {
        name: "Luxembourg",
        code: "LU"
    },
    {
        name: "Madagascar",
        code: "MG"
    },
    {
        name: "Malawi",
        code: "MW"
    },
    {
        name: "Malaysia",
        code: "MY"
    },
    {
        name: "Maldives",
        code: "MV"
    },
    {
        name: "Mali",
        code: "ML"
    },
    {
        name: "Malta",
        code: "MT"
    },
    {
        name: "Marshall Islands",
        code: "MH"
    },
    {
        name: "Mauritania",
        code: "MR"
    },
    {
        name: "Mauritius",
        code: "MU"
    },
    {
        name: "Mexico",
        code: "MX"
    },
    {
        name: "Micronesia",
        code: "FM"
    },
    {
        name: "Moldova",
        code: "MD"
    },
    {
        name: "Monaco",
        code: "MC"
    },
    {
        name: "Mongolia",
        code: "MN"
    },
    {
        name: "Montenegro",
        code: "ME"
    },
    {
        name: "Morocco",
        code: "MA"
    },
    {
        name: "Mozambique",
        code: "MZ"
    },
    {
        name: "Myanmar",
        code: "MM"
    },
    {
        name: "Namibia",
        code: "NA"
    },
    {
        name: "Nauru",
        code: "NR"
    },
    {
        name: "Nepal",
        code: "NP"
    },
    {
        name: "Netherlands",
        code: "NL"
    },
    {
        name: "New Zealand",
        code: "NZ"
    },
    {
        name: "Nicaragua",
        code: "NI"
    },
    {
        name: "Niger",
        code: "NE"
    },
    {
        name: "Nigeria",
        code: "NG"
    },
    {
        name: "North Macedonia",
        code: "MK"
    },
    {
        name: "Norway",
        code: "NO"
    },
    {
        name: "Oman",
        code: "OM"
    },
    {
        name: "Pakistan",
        code: "PK"
    },
    {
        name: "Palau",
        code: "PW"
    },
    {
        name: "Panama",
        code: "PA"
    },
    {
        name: "Papua New Guinea",
        code: "PG"
    },
    {
        name: "Paraguay",
        code: "PY"
    },
    {
        name: "Peru",
        code: "PE"
    },
    {
        name: "Philippines",
        code: "PH"
    },
    {
        name: "Poland",
        code: "PL"
    },
    {
        name: "Portugal",
        code: "PT"
    },
    {
        name: "Qatar",
        code: "QA"
    },
    {
        name: "Romania",
        code: "RO"
    },
    {
        name: "Russia",
        code: "RU"
    },
    {
        name: "Rwanda",
        code: "RW"
    },
    {
        name: "Saint Kitts and Nevis",
        code: "KN"
    },
    {
        name: "Saint Lucia",
        code: "LC"
    },
    {
        name: "Saint Vincent and the Grenadines",
        code: "VC"
    },
    {
        name: "Samoa",
        code: "WS"
    },
    {
        name: "San Marino",
        code: "SM"
    },
    {
        name: "Sao Tome and Principe",
        code: "ST"
    },
    {
        name: "Saudi Arabia",
        code: "SA"
    },
    {
        name: "Senegal",
        code: "SN"
    },
    {
        name: "Serbia",
        code: "RS"
    },
    {
        name: "Seychelles",
        code: "SC"
    },
    {
        name: "Sierra Leone",
        code: "SL"
    },
    {
        name: "Singapore",
        code: "SG"
    },
    {
        name: "Slovakia",
        code: "SK"
    },
    {
        name: "Slovenia",
        code: "SI"
    },
    {
        name: "Solomon Islands",
        code: "SB"
    },
    {
        name: "Somalia",
        code: "SO"
    },
    {
        name: "South Africa",
        code: "ZA"
    },
    {
        name: "South Sudan",
        code: "SS"
    },
    {
        name: "Spain",
        code: "ES"
    },
    {
        name: "Sri Lanka",
        code: "LK"
    },
    {
        name: "Sudan",
        code: "SD"
    },
    {
        name: "Suriname",
        code: "SR"
    },
    {
        name: "Sweden",
        code: "SE"
    },
    {
        name: "Switzerland",
        code: "CH"
    },
    {
        name: "Syria",
        code: "SY"
    },
    {
        name: "Taiwan",
        code: "TW"
    },
    {
        name: "Tajikistan",
        code: "TJ"
    },
    {
        name: "Tanzania",
        code: "TZ"
    },
    {
        name: "Thailand",
        code: "TH"
    },
    {
        name: "Togo",
        code: "TG"
    },
    {
        name: "Tonga",
        code: "TO"
    },
    {
        name: "Trinidad and Tobago",
        code: "TT"
    },
    {
        name: "Tunisia",
        code: "TN"
    },
    {
        name: "Turkey",
        code: "TR"
    },
    {
        name: "Turkmenistan",
        code: "TM"
    },
    {
        name: "Tuvalu",
        code: "TV"
    },
    {
        name: "Uganda",
        code: "UG"
    },
    {
        name: "Ukraine",
        code: "UA"
    },
    {
        name: "United Arab Emirates",
        code: "AE"
    },
    {
        name: "United Kingdom",
        code: "GB"
    },
    {
        name: "United States",
        code: "US"
    },
    {
        name: "Uruguay",
        code: "UY"
    },
    {
        name: "Uzbekistan",
        code: "UZ"
    },
    {
        name: "Vanuatu",
        code: "VU"
    },
    {
        name: "Vatican City",
        code: "VA"
    },
    {
        name: "Venezuela",
        code: "VE"
    },
    {
        name: "Vietnam",
        code: "VN"
    },
    {
        name: "Yemen",
        code: "YE"
    },
    {
        name: "Zambia",
        code: "ZM"
    },
    {
        name: "Zimbabwe",
        code: "ZW"
    }
];
var MENA_COUNTRIES_CODES = (/* unused pure expression or super */ null && ([
    "dz",
    "bh",
    "eg",
    "iq",
    "jo",
    "kw",
    "lb",
    "ly",
    "ma",
    "om",
    "ps",
    "qa",
    "sa",
    "sd",
    "sy",
    "tn",
    "ae",
    "so",
    "ye",
    "mr",
    "dj",
    "td"
]));

// EXTERNAL MODULE: ./env/environment.js
var environment = __webpack_require__(19142);
// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(93434);
;// CONCATENATED MODULE: ./components/advertise/GetInTouchForm/index.tsx











function GetInTouchForm(param) {
    var product = param.product;
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = (0,react.useState)({
        firstName: "",
        lastName: "",
        email: "",
        company: "",
        phone: "",
        country: "",
        source: "",
        sourceOther: ""
    }), formData = ref[0], setFormData = ref[1];
    var ref1 = (0,react.useState)(false), isLoading = ref1[0], setIsLoading = ref1[1];
    var ref2 = (0,react.useState)([]), invalidFields = ref2[0], setInvalidFields = ref2[1];
    var validationMessages = {
        firstName: t("Minimum 3 characters required"),
        lastName: t("Minimum 3 characters required"),
        email: t("Wrong email format"),
        company: t("Minimum 3 characters required"),
        phone: t("invalid_phone_number"),
        country: t("Minimum 2 characters required")
    };
    var sourceOptions = [
        {
            name: t("advertise_source_search"),
            id: 0
        },
        {
            name: t("advertise_source_referral"),
            id: 1
        },
        {
            name: t("adverstive_source_anghami_ads"),
            id: 2
        },
        {
            name: t("advertise_source_linkedin"),
            id: 3
        },
        {
            name: t("advertise_source_artist"),
            id: 4
        },
        {
            name: t("advertise_source_other"),
            id: 5
        }
    ];
    var handleSubmit = function(event) {
        event.preventDefault();
        setInvalidFields([]);
        var validationRegex = {
            firstName: /^.{3,}$/,
            lastName: /^.{3,}$/,
            email: /^\S+@\S+\.\S+$/,
            company: /^.{3,}$/,
            phone: /^\+*[0-9]{7,}$/,
            country: /^.{2,}$/ // Minimum 2 characters
        };
        var invalidFields = [];
        for(var field in formData){
            if (validationRegex[field] && !validationRegex[field].test(formData[field])) {
                invalidFields.push(field);
            }
        }
        if (invalidFields.length > 0) {
            setInvalidFields(invalidFields);
            return;
        }
        setIsLoading(true);
        var body = new URLSearchParams();
        body.append("type", "GETbrandpage");
        body.append("firstname", formData.firstName);
        body.append("lastname", formData.lastName);
        body.append("email", formData.email);
        body.append("company", formData.company);
        body.append("country", formData.country);
        body.append("phone", formData.phone);
        body.append("source", formData.source);
        if (product) {
            body.append("product", product);
        }
        fetch(environment.environment.gateway_prod_endpoint, {
            method: "POST",
            body: body.toString(),
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }).then(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(response) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    setIsLoading(false);
                    if (!response.ok) {
                        throw new Error("An error has occurred. Please try again!");
                    } else {
                        return [
                            2,
                            response.json()
                        ];
                    }
                    return [
                        2
                    ];
                });
            });
            return function(response) {
                return _ref.apply(this, arguments);
            };
        }()).then(function(data) {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            var responseData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                title: data.message || "Thank you for submitting the form!",
                displaymode: "toast"
            });
        // TODO: handle response here
        // console.log(responseData);
        }).catch(function(error) {
            setIsLoading(false);
            throw error;
        });
    };
    var handleChange = function(event) {
        var _target = event.target, name = _target.name, value = _target.value;
        setFormData(function(prevFormData) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevFormData), (0,_define_property/* default */.Z)({}, name, value));
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (getintouchform_module_default()).sectionContainer,
        id: "advertise_getintouch",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (getintouchform_module_default()).sectionTitle,
                children: t("advertise_get_in_touch_title")
            }),
            product === "advertise" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (getintouchform_module_default()).sectionDescription,
                children: t("advertise_get_in_touch_subtitle")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: (getintouchform_module_default()).form,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (getintouchform_module_default()).coupledQuestions,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (getintouchform_module_default()).column,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "text",
                                        name: "firstName",
                                        placeholder: t("First name"),
                                        value: formData.firstName,
                                        className: invalidFields.includes("firstName") ? (getintouchform_module_default()).invalidField : "",
                                        onChange: handleChange
                                    }),
                                    invalidFields.includes("firstName") && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: validationMessages.firstName
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (getintouchform_module_default()).column,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "text",
                                        name: "lastName",
                                        placeholder: t("Last name"),
                                        value: formData.lastName,
                                        className: invalidFields.includes("lastName") ? (getintouchform_module_default()).invalidField : "",
                                        onChange: handleChange
                                    }),
                                    invalidFields.includes("lastName") && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: validationMessages.lastName
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (getintouchform_module_default()).coupledQuestions,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (getintouchform_module_default()).column,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "email",
                                        name: "email",
                                        placeholder: t("Email"),
                                        value: formData.email,
                                        className: invalidFields.includes("email") ? (getintouchform_module_default()).invalidField : "",
                                        onChange: handleChange
                                    }),
                                    invalidFields.includes("email") && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: validationMessages.email
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (getintouchform_module_default()).column,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "text",
                                        name: "company",
                                        placeholder: t("company"),
                                        value: formData.company,
                                        className: invalidFields.includes("company") ? (getintouchform_module_default()).invalidField : "",
                                        onChange: handleChange
                                    }),
                                    invalidFields.includes("company") && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: validationMessages.company
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (getintouchform_module_default()).coupledQuestions,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (getintouchform_module_default()).column,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "tel",
                                        name: "phone",
                                        placeholder: t("Mobile number"),
                                        value: formData.phone,
                                        className: invalidFields.includes("phone") ? (getintouchform_module_default()).invalidField : "",
                                        onChange: handleChange
                                    }),
                                    invalidFields.includes("phone") && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: validationMessages.phone
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (getintouchform_module_default()).column,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                        name: "country",
                                        value: formData.country,
                                        className: invalidFields.includes("country") ? (getintouchform_module_default()).invalidField : "",
                                        onChange: handleChange,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                value: "",
                                                children: t("Country")
                                            }),
                                            allCountries.map(function(c) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                    value: c.name,
                                                    children: c.name
                                                }, c.name);
                                            })
                                        ]
                                    }),
                                    invalidFields.includes("country") && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: validationMessages.country
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                        name: "source",
                        className: (getintouchform_module_default()).dropdown,
                        value: formData.source,
                        onChange: handleChange,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: "",
                                children: t("advertise_source_title")
                            }),
                            sourceOptions.map(function(h) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: h.name,
                                    children: h.name
                                }, h.id);
                            })
                        ]
                    }),
                    formData.source === "Other" && /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "text",
                        name: "sourceOther",
                        placeholder: "",
                        value: formData.sourceOther,
                        className: (getintouchform_module_default()).otherInput,
                        onChange: handleChange
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "submit",
                        className: (getintouchform_module_default()).sendButton,
                        onClick: handleSubmit,
                        children: isLoading ? "On the way...✈️" : t("Send")
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var advertise_GetInTouchForm = (GetInTouchForm);


/***/ }),

/***/ 89429:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"d-flex":"getintouchform_d-flex__owhds","f-column":"getintouchform_f-column__xcdjJ","f-justify-center":"getintouchform_f-justify-center__MZWb9","f-justify-between":"getintouchform_f-justify-between__ldGTY","f-justify-start":"getintouchform_f-justify-start__yF0CW","f-justify-end":"getintouchform_f-justify-end__cLh76","f-align-center":"getintouchform_f-align-center__sfHbC","f-align-start":"getintouchform_f-align-start__YfHRD","f-align-stretch":"getintouchform_f-align-stretch__h1LEA","f-align-end":"getintouchform_f-align-end__tftRD","f-center":"getintouchform_f-center__irr5e","position-relative":"getintouchform_position-relative__iw_am","w-100":"getintouchform_w-100__3a_Hm","sectionContainer":"getintouchform_sectionContainer__urJv9","sectionDescription":"getintouchform_sectionDescription__8LSgY","sectionTitle":"getintouchform_sectionTitle__qoM8d","form":"getintouchform_form__IF4Ew","coupledQuestions":"getintouchform_coupledQuestions__sYTlk","dropdown":"getintouchform_dropdown__RcDJN","otherInput":"getintouchform_otherInput__WTxQs","sendButton":"getintouchform_sendButton__vdH2e","invalidField":"getintouchform_invalidField__Fouw6","column":"getintouchform_column__zbbkx"};

/***/ })

}]);